import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Container from '@material-ui/core/Container';
import Paper from "@material-ui/core/Paper";
import Box from "@material-ui/core/Box";
import Typography from '@material-ui/core/Typography';
import Chip from '@material-ui/core/Chip';
import { Grid } from "@material-ui/core";


const useStyles = makeStyles((theme) => ({
    heroContent: {
        backgroundColor: theme.palette.background.paper,
        [theme.breakpoints.down('sm')]: {
            padding: theme.spacing(0, 1, 0, 1),
          },
        [theme.breakpoints.up('md')]: {
            padding: theme.spacing(8, 0, 6),
        },
    },

    wrapText: {
        whiteSpace: 'pre-wrap'
    },
    dataBox: {
      borderRadius: 25,
      border: `3px solid ${theme.palette.primary.main}`
    },
    techBox: {
      borderRadius: 25,
      border: `3px solid ${theme.palette.secondary.main}`
    },
    techChip: {
      margin: '4px'
    }
}));

function ProjectPostHero(props) {
    const classes = useStyles();
    return (
        <div className={classes.heroContent}>
          <Container maxWidth="lg">
            <Grid container spacing={4}>
              <Grid item key={1} xs={12} sm={12} md={12} lg={8}>
                <Paper className={classes.dataBox} elevation={15}>
                  <Box p={1}>
                    <Typography variant="h5" align="center" color="textPrimary" gutterBottom>
                        Data
                    </Typography>
                    <Typography variant="body1" align="center" color="textPrimary" paragraph className={classes.wrapText}>
                        {props.data}
                    </Typography>
                    <Typography variant="body1" align="center" color="textSecondary" paragraph className={classes.wrapText}>
                        <a href={props.url} target="_blank" rel="noreferrer">Get the dataset here</a>
                    </Typography>
                  </Box>
                </Paper>
              </Grid>
              <Grid item key={2} xs={12} sm={12} md={12} lg={4}>
              <Paper className={classes.techBox} elevation={15}>
                <Box p={1}>
                  <Typography variant="h5" align="center" color="textPrimary" gutterBottom>
                      Technologies
                  </Typography>
                  <Typography variant="body1" align="center" color="textPrimary" paragraph className={classes.wrapText}>
                    {props.techs.map((tech) => (
                      <Chip label={`${tech}`} clickable color='secondary' className={classes.techChip}/>
                    ))}
                  </Typography>
                </Box>
              </Paper>
              </Grid>
            </Grid>
          </Container>
        </div>
    )
}

export default ProjectPostHero;
